import React, { useCallback } from 'react';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import StudentDetailsHeader from 'modules/students/components/StudentDetailsHeader';

import { useStudent } from 'modules/students/hooks';

import useStudentDetailsTabPages from './useStudentDetailsTabPages';

const StudentDetailsPage = () => {
  const intl = useIntl();
  const history = useHistory();

  const { courseId, studentId } = useParams<{ courseId: string; studentId: string }>();

  const { student, loading } = useStudent({ courseId, studentId });

  const { tabs, activePage, onGoToTab } = useStudentDetailsTabPages();

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/students`);
  }, [history, courseId]);

  return (
    <Box>
      <BackButton subtitle={intl.formatMessage({ id: 'quickLink.students' })} onGoBack={onGoBack} />
      <StudentDetailsHeader student={student} loading={loading} tabs={tabs} activeTab={activePage?.tab} onGoToTab={onGoToTab} />
      {activePage?.page && <Box mt={1}>{activePage.page}</Box>}
      {!activePage && <Redirect to="assignments" />}
    </Box>
  );
};

export default StudentDetailsPage;
